export { default } from './AccountCard';
